import React from 'react';

import type { Section } from '../../../../models';
import { NATURAL_GAS } from '../../../../constants';
import UtilitiesIndividuallyMetered from '../Utilities/UtilitiesCalculation/UtilitiesIndividuallyMetered';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function NaturalGasIndividuallyMetered({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesIndividuallyMetered
      section={section}
      setSectionValues={setSectionValues}
      utilityIndividuallyMeteredField={NATURAL_GAS.FIELD_NAME.INDIVIDUALLY_METERED}
      utilityName="Natural gas"
    />
  );
}

export default NaturalGasIndividuallyMetered;
